import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { carouselItems } from '@/mocks/siteData';

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = carouselItems.length;

  const go = useCallback((next: number) => setIndex((next + total) % total), [total]);

  useEffect(() => {
    const timer = setInterval(() => setIndex((prev) => (prev + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const active = carouselItems[index];

  return (
    <div className="relative h-[380px] overflow-hidden rounded-lg md:h-[480px]">
      {carouselItems.map((item, i) => (
        <Link
          key={item.id}
          to={item.link}
          aria-hidden={i !== index}
          tabIndex={i === index ? 0 : -1}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? 'opacity-100' : 'pointer-events-none opacity-0'
          }`}
        >
          <img
            src={item.image}
            alt={item.title}
            title={`${item.title} 黄金行情`}
            className="h-full w-full object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/85 via-secondary-950/40 to-secondary-950/20"></div>
        </Link>
      ))}

      <div className="pointer-events-none absolute inset-x-0 bottom-0 p-6 md:p-9">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-foreground-950">
            <i className="ri-flashlight-fill" aria-hidden="true"></i>
            {active.tag}
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
            <Link to={active.link} className="pointer-events-auto hover:text-primary-200">
              {active.title}
            </Link>
          </h2>
          <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-background-100/90 md:text-base">
            {active.desc}
          </p>
          <div className="pointer-events-auto mt-5 flex items-center gap-4">
            <Link
              to={active.link}
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-foreground-950 transition-colors hover:bg-primary-400 whitespace-nowrap"
            >
              查看详情
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
            <span className="text-xs text-background-100/70">{active.date}</span>
          </div>
        </div>
      </div>

      <div className="absolute right-5 top-5 flex items-center gap-2">
        <button
          type="button"
          aria-label="上一条"
          onClick={() => go(index - 1)}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-primary-500 hover:text-foreground-950 cursor-pointer"
        >
          <i className="ri-arrow-left-s-line text-xl" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          aria-label="下一条"
          onClick={() => go(index + 1)}
          className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-primary-500 hover:text-foreground-950 cursor-pointer"
        >
          <i className="ri-arrow-right-s-line text-xl" aria-hidden="true"></i>
        </button>
      </div>

      <div className="absolute bottom-6 right-6 hidden items-center gap-2 md:flex">
        {carouselItems.map((item, i) => (
          <button
            key={item.id}
            type="button"
            aria-label={`第 ${i + 1} 条`}
            onClick={() => setIndex(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              i === index ? 'w-6 bg-primary-500' : 'w-3 bg-background-50/50 hover:bg-background-50/80'
            }`}
          ></button>
        ))}
      </div>
    </div>
  );
}